// import React, { useCallback, useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { useNavigate, useParams } from "react-router-dom";

// import { FaArrowLeft } from "react-icons/fa";

// import { toast } from "react-toastify";

// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";

// import PageLoader from "../../helpers/PageLoader";
// import OnboardingPhaseAccordion from "./OnboardingPhaseAccordion";
// import OnboardingHistoryDrawer from "./OnboardingHistoryDrawer";
// import {
//   History,
//   ClipboardList,
//   CheckCircle2,
//   Clock3,
//   TrendingUp,
//   Building2,
//   User,
//   Mail,
//   Phone,
//   Briefcase,
//   Target,
//   Calendar,
//   MapPin,
//   BadgeIndianRupee,
//   Circle,
//   Loader2,
// } from "lucide-react";
// import { formatDateTime } from "../../helpers/formatDateTime";
// const ViewClientOnboarding = () => {
//   const navigate = useNavigate();

//   const { clientId } = useParams();

//   const [loading, setLoading] = useState(true);

//   const [onboarding, setOnboarding] = useState(null);

//   const [dashboard, setDashboard] = useState(null);

//   const [history, setHistory] = useState([]);

//   const [historyOpen, setHistoryOpen] = useState(false);

//   const [openPhases, setOpenPhases] = useState({
//     "PHASE 01": true,
//   });

//   const groupedPhases =
//     onboarding?.items?.reduce((acc, item) => {
//       if (!acc[item.phase]) {
//         acc[item.phase] = {
//           color: item.color || "#DC2626",
//           accent: item.accent || "#FEE2E2",
//           applicableFor: item.applicableFor || [],
//           sections: {},
//         };
//       }

//       if (!acc[item.phase].sections[item.sectionTitle]) {
//         acc[item.phase].sections[item.sectionTitle] = [];
//       }

//       acc[item.phase].sections[item.sectionTitle].push(item);

//       return acc;
//     }, {}) || {};

//   const fetchData = useCallback(async () => {
//     try {
//       setLoading(true);

//       const [onboardingRes, dashboardRes, historyRes] = await Promise.all([
//         api({
//           ...SummaryApi.getOneClientOnboarding,
//           url: SummaryApi.getOneClientOnboarding.url(clientId),
//         }),

//         api({
//           ...SummaryApi.getClientOnboardingDashboard,
//           url: SummaryApi.getClientOnboardingDashboard.url(clientId),
//         }),

//         api({
//           ...SummaryApi.getClientOnboardingHistory,
//           url: SummaryApi.getClientOnboardingHistory.url(clientId),
//         }),
//       ]);

//       setOnboarding(onboardingRes.data.data);

//       setDashboard(dashboardRes.data.data);

//       setHistory(historyRes.data.data || []);
//     } catch (error) {
//       console.log("ERROR =>", error);

//       toast.error(
//         error?.response?.data?.message ||
//           error?.message ||
//           "Failed to load onboarding details",
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [clientId]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const handleChecklistUpdate = async (payload) => {
//     try {
//       await api({
//         ...SummaryApi.updateClientOnboardingChecklist,
//         data: payload,
//       });

//       toast.success("Checklist updated");

//       fetchData();
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Update failed");
//     }
//   };

//   const totalItems = dashboard?.totalItems || 0;
//   const cards = [
//     {
//       title: "Total Items",
//       value: dashboard?.totalItems || 0,
//       icon: ClipboardList,
//       bg: "from-blue-500 via-blue-600 to-indigo-600",
//       iconBg: "bg-white/20",
//       progress: 100,
//     },
//     {
//       title: "Completed",
//       value: dashboard?.completedItems || 0,
//       icon: CheckCircle2,
//       bg: "from-emerald-500 via-green-600 to-teal-600",
//       iconBg: "bg-white/20",
//       progress: totalItems ? (dashboard?.completedItems / totalItems) * 100 : 0,
//     },
//     {
//       title: "Pending",
//       value: dashboard?.pendingItems || 0,
//       icon: Clock3,
//       bg: "from-orange-500 via-red-500 to-red-600",
//       iconBg: "bg-white/20",
//       progress: totalItems ? (dashboard?.pendingItems / totalItems) * 100 : 0,
//     },
//     {
//       title: "Progress",
//       value: `${dashboard?.completionPercentage || 0}%`,
//       icon: TrendingUp,
//       bg: "from-violet-500 via-purple-600 to-indigo-600",
//       iconBg: "bg-white/20",
//       progress: dashboard?.completionPercentage || 0,
//     },
//   ];

//   const cardVariants = {
//     hidden: {
//       opacity: 0,
//       y: 25,
//     },
//     show: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.4,
//       },
//     },
//   };

//   const contactCards = [
//     {
//       icon: User,
//       iconColor: "text-blue-500",
//       bgColor: "bg-blue-50",
//       title: "Contact Person",
//       value: onboarding?.clientId?.contactName,
//       subValue: onboarding?.clientId?.contactDesignation,
//     },
//     {
//       icon: Mail,
//       iconColor: "text-green-500",
//       bgColor: "bg-green-50",
//       title: "Email Address",
//       value: onboarding?.clientId?.contactEmail,
//     },
//     {
//       icon: Phone,
//       iconColor: "text-orange-500",
//       bgColor: "bg-orange-50",
//       title: "Phone Number",
//       value: onboarding?.clientId?.contactPhone,
//     },
//     {
//       icon: Building2,
//       iconColor: "text-purple-500",
//       bgColor: "bg-purple-50",
//       title: "Client ID",
//       value: onboarding?.clientId?.clientId,
//     },
//   ];

//   const businessCards = [
//     {
//       icon: Briefcase,
//       iconColor: "text-indigo-500",
//       bg: "from-indigo-50 to-white",
//       title: "Industry",
//       value: onboarding?.clientId?.industrySubType,
//     },
//     {
//       icon: Target,
//       iconColor: "text-emerald-500",
//       bg: "from-emerald-50 to-white",
//       title: "Requirement",
//       value: onboarding?.clientId?.requirement?.[0],
//     },
//     {
//       icon: BadgeIndianRupee,
//       iconColor: "text-green-600",
//       bg: "from-green-50 to-white",
//       title: "Expected Value",
//       value: `₹${onboarding?.clientId?.expectedValue || 0}`,
//     },
//     {
//       icon: Calendar,
//       iconColor: "text-red-500",
//       bg: "from-red-50 to-white",
//       title: "Closing Date",
//       value: onboarding?.clientId?.expectedClosingDate
//         ? formatDateTime(onboarding.clientId.expectedClosingDate, false)
//         : "-",
//     },
//   ];

//   const phaseProgress = Object.entries(groupedPhases).map(
//     ([phaseName, phaseData]) => {
//       const allItems = Object.values(phaseData.sections).flat();

//       const completed = allItems.filter((item) => item.received).length;

//       const total = allItems.length;

//       return {
//         phaseName,
//         sectionCode: allItems?.[0]?.sectionCode || "",
//         color: allItems?.[0]?.color,
//         accent: allItems?.[0]?.accent,
//         completed,
//         total,
//         percentage: total > 0 ? Math.round((completed / total) * 100) : 0,
//       };
//     },
//   );
//   if (loading) {
//     return <PageLoader />;
//   }

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.4 }}
//       className="p-4 w-full space-y-4"
//     >
//       <div className="bg-[#DC2626] p-4 rounded-lg text-white">
//         <div className="flex justify-between items-start">
//           <div className="flex items-center gap-4">
//             <button onClick={() => navigate(-1)} className="transition-all">
//               <FaArrowLeft />
//             </button>

//             <div>
//               <h1 className="text-2xl font-bold">Client Onboarding</h1>

//               {/* <p className="text-white/80 mt-1">
//                 Track onboarding progress and checklist completion
//               </p> */}
//             </div>
//           </div>

//           <button
//             onClick={() => setHistoryOpen(true)}
//             className="flex items-center gap-2 px-5 py-3 bg-white text-red-600 rounded-lg font-semibold"
//           >
//             <History size={18} />
//             View History
//           </button>
//         </div>
//       </div>
//       {/* Client Details */}
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         className="bg-white rounded-lg shadow-sm overflow-hidden"
//       >
//         {/* Header */}
//         <div className="bg-gradient-to-r from-slate-800 via-slate-700 to-slate-900 p-8">
//           <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
//             <div className="flex items-center gap-5">
//               <div className="h-20 w-20 rounded-lg bg-emerald-500 flex items-center justify-center text-white text-3xl font-bold">
//                 {onboarding?.clientId?.clientName?.charAt(0)}
//               </div>

//               <div>
//                 <h2 className="text-3xl font-bold text-white">
//                   {onboarding?.clientId?.clientName}
//                 </h2>

//                 <p className="text-slate-300 mt-1">
//                   {onboarding?.clientId?.industryType}
//                 </p>

//                 <div className="flex flex-wrap gap-2 mt-3">
//                   <span className="px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-300 text-xs">
//                     Closed Won
//                   </span>

//                   <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-xs">
//                     {onboarding?.clientId?.productCategory?.[0]}
//                   </span>

//                   <span className="px-3 py-1 rounded-full bg-orange-500/20 text-orange-300 text-xs">
//                     {onboarding?.clientId?.requirement?.[0]}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-6">
//               <div>
//                 <p className="text-slate-400 text-sm">Deal Value</p>

//                 <h3 className="text-2xl font-bold text-white">
//                   ₹{onboarding?.clientId?.expectedValue}
//                 </h3>
//               </div>

//               <div>
//                 <p className="text-slate-400 text-sm">Total Visits</p>

//                 <h3 className="text-2xl font-bold text-white">
//                   {onboarding?.clientId?.totalVisitCount}
//                 </h3>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Body */}
//         <motion.div initial="hidden" animate="show" className="space-y-6">
//           {/* CONTACT INFORMATION */}

//           <div className="bg-white rounded-lg px-4 py-3">
//             <div className="flex items-center justify-between mb-6">
//               <div>
//                 <h3 className="text-xl font-bold text-gray-900">
//                   Contact Information
//                 </h3>

//                 <p className="text-sm text-gray-500 mt-1">
//                   Primary client communication details
//                 </p>
//               </div>

//               <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-600 text-xs font-semibold">
//                 Active Contact
//               </span>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
//               {contactCards.map((card, index) => {
//                 const Icon = card.icon;

//                 return (
//                   <motion.div
//                     key={card.title}
//                     variants={cardVariants}
//                     whileHover={{
//                       y: -5,
//                       scale: 1.02,
//                     }}
//                     transition={{
//                       delay: index * 0.08,
//                     }}
//                     className="
//               group
//               relative
//               overflow-hidden
//               rounded-lg
//               border
//               border-gray-100
//               bg-white
//               p-5
//               shadow-sm
//               hover:shadow-xl
//               transition-all
//             "
//                   >
//                     <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-blue-500 to-cyan-500" />

//                     <div
//                       className={`w-12 h-12 rounded-2xl ${card.bgColor}
//               flex items-center justify-center mb-4
//               transition-all`}
//                     >
//                       <Icon size={22} className={card.iconColor} />
//                     </div>

//                     <p className="text-xs uppercase tracking-wide text-gray-500">
//                       {card.title}
//                     </p>

//                     <h4 className="font-bold text-gray-900 mt-2 break-all">
//                       {card.value || "-"}
//                     </h4>

//                     {card.subValue && (
//                       <p className="text-sm text-gray-500 mt-1">
//                         {card.subValue}
//                       </p>
//                     )}
//                   </motion.div>
//                 );
//               })}
//             </div>
//           </div>

//           {/* BUSINESS INFORMATION */}

//           <div className="bg-white rounded-lg  px-4">
//             <div className="mb-6">
//               <h3 className="text-xl font-bold text-gray-900">
//                 Business Information
//               </h3>

//               <p className="text-sm text-gray-500 mt-1">
//                 Client business and project details
//               </p>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
//               {businessCards.map((card, index) => {
//                 const Icon = card.icon;

//                 return (
//                   <motion.div
//                     key={card.title}
//                     variants={cardVariants}
//                     whileHover={{
//                       scale: 1.03,
//                     }}
//                     transition={{
//                       delay: index * 0.08,
//                     }}
//                     className={`
//               relative
//               overflow-hidden
//               rounded-lg
//               bg-gradient-to-br
//               ${card.bg}
//               border
//               border-gray-100
//               p-5
//             `}
//                   >
//                     <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-white/60" />

//                     <Icon
//                       size={22}
//                       className={`${card.iconColor} mb-4 relative z-10`}
//                     />

//                     <p className="text-xs uppercase tracking-wide text-gray-500">
//                       {card.title}
//                     </p>

//                     <h4 className="font-bold text-gray-900 mt-2 relative z-10">
//                       {card.value || "-"}
//                     </h4>
//                   </motion.div>
//                 );
//               })}
//             </div>
//           </div>

//           {/* LOCATION */}

//           <motion.div
//             variants={cardVariants}
//             whileHover={{
//               scale: 1.01,
//             }}
//             className="
//       relative
//       overflow-hidden
//       rounded-lg
//       bg-gradient-to-r
//       from-red-50
//       via-orange-50
//       to-yellow-50      
//       p-6
//     "
//           >
//             <div className="flex items-center gap-4 mb-4">
//               <div className="w-12 h-12 rounded-2xl bg-red-500 flex items-center justify-center">
//                 <MapPin className="text-white" size={20} />
//               </div>

//               <div>
//                 <h4 className="font-bold text-lg text-gray-900">
//                   Location Details
//                 </h4>

//                 <p className="text-sm text-gray-500">
//                   Registered business address
//                 </p>
//               </div>
//             </div>

//             <p className="text-gray-700 font-medium leading-7">
//               {onboarding?.clientId?.address}
//             </p>

//             {/* <div className="flex flex-wrap gap-2 mt-4">
//       <span className="px-3 py-1 bg-white rounded-full text-sm">
//         {onboarding?.clientId?.locality}
//       </span>

//       <span className="px-3 py-1 bg-white rounded-full text-sm">
//         {onboarding?.clientId?.district}
//       </span>

//       <span className="px-3 py-1 bg-white rounded-full text-sm">
//         {onboarding?.clientId?.state}
//       </span>

//       <span className="px-3 py-1 bg-white rounded-full text-sm">
//         {onboarding?.clientId?.pincode}
//       </span>
//     </div> */}
//           </motion.div>
//         </motion.div>
//       </motion.div>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
//         {cards.map((card, index) => {
//           const Icon = card.icon;

//           return (
//             <motion.div
//               key={card.title}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{
//                 delay: index * 0.1,
//                 duration: 0.4,
//               }}
//               whileHover={{
//                 y: -8,
//                 scale: 1.03,
//               }}
//               className={`relative overflow-hidden rounded-lg bg-gradient-to-br ${card.bg} p-6 text-white shadow-xl`}
//             >
//               {/* Background Circle */}
//               <div className="absolute -right-8 -top-8 w-32 h-32 bg-white/10 rounded-full" />

//               <div className="absolute -right-4 bottom-0 w-20 h-20 bg-white/5 rounded-full" />

//               <div className="relative z-10">
//                 <div className="flex items-start justify-between">
//                   <div>
//                     <p className="text-white/80 text-sm font-medium">
//                       {card.title}
//                     </p>

//                     <h3 className="text-4xl font-bold mt-3">{card.value}</h3>
//                   </div>

//                   <div
//                     className={`${card.iconBg} p-3 rounded-2xl backdrop-blur-sm`}
//                   >
//                     <Icon size={26} />
//                   </div>
//                 </div>

//                 <div className="mt-6 flex items-center gap-2 text-sm text-white/80">
//                   <TrendingUp size={14} />
//                   <span>Updated just now</span>
//                 </div>
//                 <div className="mt-5">
//                   <div className="flex justify-between text-xs text-white/80 mb-1">
//                     <span>Status</span>
//                     <span>{Math.round(card.progress)}%</span>
//                   </div>

//                   <div className="w-full bg-white/20 h-2 rounded-full overflow-hidden">
//                     <motion.div
//                       initial={{ width: 0 }}
//                       animate={{ width: `${card.progress}%` }}
//                       transition={{
//                         duration: 1,
//                         delay: index * 0.2,
//                       }}
//                       className="h-full bg-white rounded-full"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           );
//         })}
//       </div>

//       {/* Progress Bar */}
//       <div className="bg-white rounded-lg border shadow-sm p-6">
//         <div className="mb-6">
//           <h3 className="text-xl font-bold">Onboarding Workflow</h3>

//           <p className="text-sm text-gray-500">
//             Live onboarding execution status
//           </p>
//         </div>

//         <div className="space-y-5">
//           {phaseProgress.map((phase, index) => {
//             const isCompleted = phase.percentage === 100;

//             const isRunning = phase.percentage > 0 && phase.percentage < 100;

//             return (
//               <div key={phase.phaseName} className="relative pl-12">
//                 {index !== phaseProgress.length - 1 && (
//                   <div className="absolute left-5 top-10 h-12 w-0.5 bg-gray-200" />
//                 )}

//                 <div className="absolute left-0 top-0">
//                   {isCompleted ? (
//                     <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//                       <CheckCircle2 size={20} className="text-green-600" />
//                     </div>
//                   ) : isRunning ? (
//                     <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
//                       <Loader2
//                         size={20}
//                         className="text-blue-600 animate-spin"
//                       />
//                     </div>
//                   ) : (
//                     <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
//                       <Circle size={18} className="text-gray-400" />
//                     </div>
//                   )}
//                 </div>

//                 <div className="bg-gray-50 rounded-2xl p-4 hover:bg-white hover:shadow-md transition-all">
//                   <div className="flex justify-between items-center">
//                     <div className="flex-1">
//                       <div className="flex items-center gap-2 mb-1">
//                         <h4
//                           className="font-semibold"
//                           style={{
//                             color: phase.color,
//                           }}
//                         >
//                           {phase.phaseName}
//                         </h4>

//                         <span
//                           className="px-3 py-1 rounded-full text-xs font-semibold"
//                           style={{
//                             backgroundColor: `${phase.accent}20`,
//                             color: phase.color,
//                           }}
//                         >
//                           {phase.sectionCode}
//                         </span>
//                       </div>

//                       {/* <p className="text-sm text-gray-500">
//                         {phase.sectionTitle}
//                       </p> */}

//                       <p className="text-xs text-gray-400 mt-2">
//                         {phase.completed} of {phase.total} tasks completed
//                       </p>
//                     </div>

//                     <div className="relative h-14 w-14">
//                       <svg className="h-14 w-14 rotate-[-90deg]">
//                         <circle
//                           cx="28"
//                           cy="28"
//                           r="22"
//                           stroke={`${phase.accent}30`}
//                           strokeWidth="4"
//                           fill="none"
//                         />

//                         <circle
//                           cx="28"
//                           cy="28"
//                           r="22"
//                           stroke={phase.accent}
//                           strokeWidth="4"
//                           fill="none"
//                           strokeDasharray={138}
//                           strokeDashoffset={
//                             138 - (138 * phase.percentage) / 100
//                           }
//                           strokeLinecap="round"
//                         />
//                       </svg>

//                       <div className="absolute inset-0 flex items-center justify-center">
//                         <span
//                           className="text-xs font-bold"
//                           style={{
//                             color: phase.color,
//                           }}
//                         >
//                           {phase.percentage}%
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//       <div className="space-y-4">
//         {Object.entries(groupedPhases).map(([phaseName, phaseData]) => (
//           <OnboardingPhaseAccordion
//             key={phaseName}
//             phaseName={phaseName}
//             applicableFor={phaseData.applicableFor}
//             phaseData={phaseData}
//             phaseAttachments={onboarding.phaseAttachments || []}

//             getOneClientOnboarding={fetchData}
//             clientId={onboarding.clientId._id}
//             onChecklistUpdate={handleChecklistUpdate}
//             isOpen={openPhases[phaseName]}
//             onToggle={() =>
//               setOpenPhases((prev) => ({
//                 ...prev,
//                 [phaseName]: !prev[phaseName],
//               }))
//             }
//           />
//         ))}
//       </div>
//       <OnboardingHistoryDrawer
//         open={historyOpen}
//         onClose={() => setHistoryOpen(false)}
//         history={history}
//       />
//     </motion.div>
//   );
// };

// export default ViewClientOnboarding;
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";

import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";

import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";

import PageLoader from "../../helpers/PageLoader";
import OnboardingPhaseAccordion from "./OnboardingPhaseAccordion";
import OnboardingHistoryDrawer from "./OnboardingHistoryDrawer";
import {
  History,
  ClipboardList,
  CheckCircle2,
  Clock3,
  TrendingUp,
  Building2,
  User,
  Mail,
  Phone,
  Briefcase,
  Target,
  Calendar,
  MapPin,
  BadgeIndianRupee,
  Circle,
  Loader2,
  Receipt,
  X,
  PackagePlus,
  Layers,
} from "lucide-react";
import { formatDateTime } from "../../helpers/formatDateTime";
import { productCategories as defaultProductCategories } from "../ClientVisitsComponents/IndustryData";

const ViewClientOnboarding = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();

  const [loading, setLoading] = useState(true);
  const [onboarding, setOnboarding] = useState(null);
  const [dashboard, setDashboard] = useState(null);
  const [history, setHistory] = useState([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [salesStages, setSalesStages] = useState([]);

  // Modal & Add-On States
  const [addOnModalOpen, setAddOnModalOpen] = useState(false);
  const [submittingAddOn, setSubmittingAddOn] = useState(false);
  const [addOnForm, setAddOnForm] = useState({
    productCategory: [],
    requirement: [],
    stageId: "",
    invoiceId: "",
    expectedValue: "",
    customRequirement: "",
    remarks: "",
  });

  const [openPhases, setOpenPhases] = useState({
    "PHASE 01": true,
  });

  const groupedPhases =
    onboarding?.items?.reduce((acc, item) => {
      if (!acc[item.phase]) {
        acc[item.phase] = {
          color: item.color || "#DC2626",
          accent: item.accent || "#FEE2E2",
          applicableFor: item.applicableFor || [],
          sections: {},
        };
      }

      if (!acc[item.phase].sections[item.sectionTitle]) {
        acc[item.phase].sections[item.sectionTitle] = [];
      }

      acc[item.phase].sections[item.sectionTitle].push(item);

      return acc;
    }, {}) || {};

  // Fetch Sales Stages for Stage Dropdown
  const fetchSalesStages = useCallback(async () => {
    try {
      const res = await api({
        ...SummaryApi.getAllStages,
        params: { includeInactive: false, includeShared: true },
      });
      if (res.data?.success) {
        setSalesStages(res.data.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch stages:", err);
    }
  }, []);

  useEffect(() => {
    fetchSalesStages();
  }, [fetchSalesStages]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const [onboardingRes, dashboardRes, historyRes] = await Promise.all([
        api({
          ...SummaryApi.getOneClientOnboarding,
          url: SummaryApi.getOneClientOnboarding.url(clientId),
        }),
        api({
          ...SummaryApi.getClientOnboardingDashboard,
          url: SummaryApi.getClientOnboardingDashboard.url(clientId),
        }),
        api({
          ...SummaryApi.getClientOnboardingHistory,
          url: SummaryApi.getClientOnboardingHistory.url(clientId),
        }),
      ]);

      setOnboarding(onboardingRes.data.data);
      setDashboard(dashboardRes.data.data);
      setHistory(historyRes.data.data || []);
    } catch (error) {
      console.log("ERROR =>", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to load onboarding details"
      );
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChecklistUpdate = async (payload) => {
    try {
      await api({
        ...SummaryApi.updateClientOnboardingChecklist,
        data: payload,
      });

      toast.success("Checklist updated");
      fetchData();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Update failed");
    }
  };

  // Derive available services/requirements based on selected product categories
  const availableServices = useMemo(() => {
    if (!addOnForm.productCategory.length) return [];
    const services = [];
    addOnForm.productCategory.forEach((catName) => {
      const found = defaultProductCategories?.find(
        (c) => c.productCategory.toLowerCase() === catName.toLowerCase()
      );
      if (found?.subCategories) {
        found.subCategories.forEach((sub) => {
          if (!services.includes(sub) && !sub.includes("Others")) {
            services.push(sub);
          }
        });
      }
    });
    return services;
  }, [addOnForm.productCategory]);

  const handleCategoryToggle = (catName) => {
    setAddOnForm((prev) => {
      const exists = prev.productCategory.includes(catName);
      const updatedCategories = exists
        ? prev.productCategory.filter((c) => c !== catName)
        : [...prev.productCategory, catName];

      const validRequirements = prev.requirement.filter((req) => {
        return updatedCategories.some((cName) => {
          const found = defaultProductCategories?.find(
            (c) => c.productCategory.toLowerCase() === cName.toLowerCase()
          );
          return found?.subCategories?.includes(req);
        });
      });

      return {
        ...prev,
        productCategory: updatedCategories,
        requirement: validRequirements,
      };
    });
  };

  const handleServiceToggle = (serviceName) => {
    setAddOnForm((prev) => {
      const exists = prev.requirement.includes(serviceName);
      return {
        ...prev,
        requirement: exists
          ? prev.requirement.filter((s) => s !== serviceName)
          : [...prev.requirement, serviceName],
      };
    });
  };

  const handleAddOnSubmit = async (e) => {
    e.preventDefault();

    if (!addOnForm.productCategory.length) {
      toast.error("Please select at least one product category");
      return;
    }

    try {
      setSubmittingAddOn(true);
      const clientInfo = onboarding?.clientId;

      let finalRequirements = [...addOnForm.requirement];
      if (addOnForm.customRequirement?.trim()) {
        finalRequirements.push(addOnForm.customRequirement.trim());
      }

      const payload = {
        clientName: clientInfo?.clientName,
        contactName: clientInfo?.contactName,
        contactPhone: clientInfo?.contactPhone,
        contactEmail: clientInfo?.contactEmail,
        divisionId: clientInfo?.divisionId?._id || clientInfo?.divisionId,
        industryType: clientInfo?.industryType,
        industrySubType: clientInfo?.industrySubType,
        address: clientInfo?.address,
        productCategory: addOnForm.productCategory,
        invoiceId: addOnForm.invoiceId,
        expectedValue: Number(addOnForm.expectedValue) || 0,
        estimatedValue: Number(addOnForm.expectedValue) || 0,
        requirement: finalRequirements,
        remarks: addOnForm.remarks || "Add-on product purchase",
        // Send selected stageId or undefined so backend sets initial stage Order 1
        ...(addOnForm.stageId && { stageId: addOnForm.stageId }),
      };

      await api({
        ...SummaryApi.createRepeatClientVisit,
        data: payload,
      });

      toast.success("Add-on service added & checklists synced!");
      setAddOnModalOpen(false);
      setAddOnForm({
        productCategory: [],
        requirement: [],
        stageId: "",
        invoiceId: "",
        expectedValue: "",
        customRequirement: "",
        remarks: "",
      });

      fetchData();
    } catch (error) {
      console.error("Add-on Submit Error:", error);
      toast.error(
        error?.response?.data?.message || "Failed to add service"
      );
    } finally {
      setSubmittingAddOn(false);
    }
  };

  const totalItems = dashboard?.totalItems || 0;
  const cards = [
    {
      title: "Total Items",
      value: dashboard?.totalItems || 0,
      icon: ClipboardList,
      bg: "from-blue-500 via-blue-600 to-indigo-600",
      iconBg: "bg-white/20",
      progress: 100,
    },
    {
      title: "Completed",
      value: dashboard?.completedItems || 0,
      icon: CheckCircle2,
      bg: "from-emerald-500 via-green-600 to-teal-600",
      iconBg: "bg-white/20",
      progress: totalItems ? (dashboard?.completedItems / totalItems) * 100 : 0,
    },
    {
      title: "Pending",
      value: dashboard?.pendingItems || 0,
      icon: Clock3,
      bg: "from-orange-500 via-red-500 to-red-600",
      iconBg: "bg-white/20",
      progress: totalItems ? (dashboard?.pendingItems / totalItems) * 100 : 0,
    },
    {
      title: "Progress",
      value: `${dashboard?.completionPercentage || 0}%`,
      icon: TrendingUp,
      bg: "from-violet-500 via-purple-600 to-indigo-600",
      iconBg: "bg-white/20",
      progress: dashboard?.completionPercentage || 0,
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  const contactCards = [
    {
      icon: User,
      iconColor: "text-blue-500",
      bgColor: "bg-blue-50",
      title: "Contact Person",
      value: onboarding?.clientId?.contactName,
      subValue: onboarding?.clientId?.contactDesignation,
    },
    {
      icon: Mail,
      iconColor: "text-green-500",
      bgColor: "bg-green-50",
      title: "Email Address",
      value: onboarding?.clientId?.contactEmail,
    },
    {
      icon: Phone,
      iconColor: "text-orange-500",
      bgColor: "bg-orange-50",
      title: "Phone Number",
      value: onboarding?.clientId?.contactPhone,
    },
    {
      icon: Building2,
      iconColor: "text-purple-500",
      bgColor: "bg-purple-50",
      title: "Client ID",
      value: onboarding?.clientId?.clientId,
    },
  ];

  const businessCards = [
    {
      icon: Briefcase,
      iconColor: "text-indigo-500",
      bg: "from-indigo-50/50 via-slate-50/20 to-white",
      title: "Industry",
      value: onboarding?.clientId?.industrySubType || onboarding?.clientId?.industryType,
    },
    {
      icon: Target,
      iconColor: "text-emerald-500",
      bg: "from-emerald-50/50 via-slate-50/20 to-white",
      title: "Requirement",
      value: onboarding?.clientId?.requirement?.[0] || "N/A",
    },
    {
      icon: BadgeIndianRupee,
      iconColor: "text-green-600",
      bg: "from-green-50/50 via-slate-50/20 to-white",
      title: "Expected Value",
      value: `₹${onboarding?.clientId?.expectedValue || 0}`,
    },
    {
      icon: Calendar,
      iconColor: "text-red-500",
      bg: "from-red-50/50 via-slate-50/20 to-white",
      title: "Closing Date",
      value: onboarding?.clientId?.expectedClosingDate
        ? formatDateTime(onboarding.clientId.expectedClosingDate, false)
        : "-",
    },
  ];

  const phaseProgress = Object.entries(groupedPhases).map(
    ([phaseName, phaseData]) => {
      const allItems = Object.values(phaseData.sections).flat();
      const completed = allItems.filter((item) => item.received).length;
      const total = allItems.length;

      return {
        phaseName,
        sectionCode: allItems?.[0]?.sectionCode || "",
        color: allItems?.[0]?.color,
        accent: allItems?.[0]?.accent,
        completed,
        total,
        percentage: total > 0 ? Math.round((completed / total) * 100) : 0,
      };
    }
  );

  if (loading) {
    return <PageLoader />;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="p-3 sm:p-5 w-full space-y-4 max-w-[1600px] mx-auto"
    >
      {/* Top Banner */}
      <div className="bg-[#DC2626] p-4 rounded-xl text-white shadow-md">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-white/10 rounded-lg transition-all text-white"
            >
              <FaArrowLeft size={16} />
            </button>
            <div>
              <h1 className="text-xl sm:text-2xl font-bold">Client Onboarding</h1>
            </div>
          </div>

          <button
            onClick={() => setHistoryOpen(true)}
            className="flex items-center gap-2 px-4 py-2 bg-white text-[#DC2626] rounded-lg text-sm font-semibold shadow hover:bg-red-50 transition-all self-end sm:self-auto"
          >
            <History size={16} />
            View History
          </button>
        </div>
      </div>

      {/* Main Client Card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden"
      >
        {/* Dark Slate Hero Header */}
        <div className="bg-gradient-to-r from-slate-800 via-slate-700 to-slate-900 p-5 sm:p-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div className="flex items-center gap-4 sm:gap-5">
              <div className="h-16 w-16 sm:h-20 sm:w-20 rounded-xl bg-emerald-500 flex items-center justify-center text-white text-2xl sm:text-3xl font-bold uppercase shadow-inner shrink-0">
                {onboarding?.clientId?.clientName?.charAt(0)}
              </div>

              <div>
                <h2 className="text-2xl sm:text-3xl font-bold text-white leading-tight">
                  {onboarding?.clientId?.clientName}
                </h2>
                <p className="text-slate-300 text-sm mt-0.5">
                  {onboarding?.clientId?.industryType}
                </p>

                <div className="flex flex-wrap gap-2 mt-2.5">
                  <span className="px-3 py-0.5 rounded-full bg-emerald-500/20 text-emerald-300 text-xs font-semibold border border-emerald-500/30">
                    Closed Won
                  </span>
                  {onboarding?.clientId?.productCategory?.map((cat, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-0.5 rounded-full bg-blue-500/20 text-blue-300 text-xs font-semibold uppercase border border-blue-500/30"
                    >
                      {cat}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 sm:gap-8 border-t lg:border-t-0 border-slate-700/60 pt-4 lg:pt-0">
              <div>
                <p className="text-slate-400 text-xs sm:text-sm">Deal Value</p>
                <h3 className="text-xl sm:text-2xl font-bold text-white">
                  ₹{onboarding?.clientId?.expectedValue || 0}
                </h3>
              </div>

              <div>
                <p className="text-slate-400 text-xs sm:text-sm">Total Visits</p>
                <h3 className="text-xl sm:text-2xl font-bold text-white">
                  {onboarding?.clientId?.totalVisitCount || 1}
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* Content Body */}
        <div className="space-y-6 p-4 sm:p-6">
          {/* CONTACT INFORMATION */}
          <div>
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                  Contact Information
                </h3>
                <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
                  Primary client communication details
                </p>
              </div>
              <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-600 text-xs font-semibold border border-blue-100">
                Active Contact
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {contactCards.map((card) => {
                const Icon = card.icon;
                return (
                  <motion.div
                    key={card.title}
                    variants={cardVariants}
                    whileHover={{ y: -3 }}
                    className="relative overflow-hidden rounded-xl border border-slate-100 bg-white p-4 shadow-sm hover:shadow-md transition-all"
                  >
                    <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-blue-500 to-cyan-500" />
                    <div
                      className={`w-10 h-10 rounded-xl ${card.bgColor} flex items-center justify-center mb-3`}
                    >
                      <Icon size={20} className={card.iconColor} />
                    </div>
                    <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">
                      {card.title}
                    </p>
                    <h4 className="font-bold text-gray-900 text-sm sm:text-base mt-1 break-all">
                      {card.value || "-"}
                    </h4>
                    {card.subValue && (
                      <p className="text-xs text-gray-500 mt-0.5">
                        {card.subValue}
                      </p>
                    )}
                  </motion.div>
                );
              })}
            </div>
          </div>

          {/* BUSINESS INFORMATION WITH ADD-ON BUTTON */}
          <div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                    Business Information
                  </h3>
                  {onboarding?.clientId?.invoiceId && (
                    <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-0.5 bg-blue-50 text-blue-700 rounded-md border border-blue-200">
                      <Receipt size={12} />
                      Invoice: {onboarding.clientId.invoiceId}
                    </span>
                  )}
                </div>
                <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
                  Client business and project details
                </p>
              </div>

              <button
                onClick={() => setAddOnModalOpen(true)}
                className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-[#DC2626] text-white rounded-lg text-xs sm:text-sm font-semibold shadow hover:bg-[#B91C1C] active:scale-95 transition-all w-full sm:w-auto"
              >
                <PackagePlus size={16} />
                + Add-On Service
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {businessCards.map((card) => {
                const Icon = card.icon;
                return (
                  <motion.div
                    key={card.title}
                    variants={cardVariants}
                    whileHover={{ scale: 1.02 }}
                    className={`relative overflow-hidden rounded-xl bg-gradient-to-br ${card.bg} border border-slate-100 p-4 shadow-sm`}
                  >
                    <Icon size={20} className={`${card.iconColor} mb-3`} />
                    <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">
                      {card.title}
                    </p>
                    <h4 className="font-bold text-gray-900 text-sm sm:text-base mt-1 break-words">
                      {card.value || "-"}
                    </h4>
                  </motion.div>
                );
              })}
            </div>
          </div>

          {/* LOCATION */}
          <motion.div
            variants={cardVariants}
            className="relative overflow-hidden rounded-xl bg-gradient-to-r from-red-50/60 via-orange-50/40 to-amber-50/40 border border-red-100/60 p-5"
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-xl bg-[#DC2626] flex items-center justify-center text-white shrink-0">
                <MapPin size={18} />
              </div>
              <div>
                <h4 className="font-bold text-base text-gray-900">
                  Location Details
                </h4>
                <p className="text-xs text-gray-500">
                  Registered business address
                </p>
              </div>
            </div>
            <p className="text-gray-700 text-sm font-medium leading-relaxed pl-13">
              {onboarding?.clientId?.address || "No address details available"}
            </p>
          </motion.div>
        </div>
      </motion.div>

      {/* Summary Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((card, index) => {
          const Icon = card.icon;
          return (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08, duration: 0.3 }}
              whileHover={{ y: -4 }}
              className={`relative overflow-hidden rounded-xl bg-gradient-to-br ${card.bg} p-5 text-white shadow-lg`}
            >
              <div className="absolute -right-6 -top-6 w-24 h-24 bg-white/10 rounded-full" />
              <div className="relative z-10">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="text-white/80 text-xs font-semibold uppercase tracking-wider">
                      {card.title}
                    </p>
                    <h3 className="text-3xl font-bold mt-2">{card.value}</h3>
                  </div>
                  <div className={`${card.iconBg} p-2.5 rounded-xl backdrop-blur-sm`}>
                    <Icon size={22} />
                  </div>
                </div>

                <div className="mt-4">
                  <div className="flex justify-between text-[11px] text-white/80 mb-1 font-medium">
                    <span>Progress</span>
                    <span>{Math.round(card.progress)}%</span>
                  </div>
                  <div className="w-full bg-white/20 h-1.5 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: `${card.progress}%` }}
                      transition={{ duration: 0.8, delay: index * 0.1 }}
                      className="h-full bg-white rounded-full"
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* Onboarding Workflow Timeline */}
      <div className="bg-white rounded-xl border border-slate-100 shadow-sm p-4 sm:p-6">
        <div className="mb-5">
          <h3 className="text-lg sm:text-xl font-bold text-gray-900">
            Onboarding Workflow
          </h3>
          <p className="text-xs sm:text-sm text-gray-500">
            Live onboarding execution status
          </p>
        </div>

        <div className="space-y-4">
          {phaseProgress.map((phase, index) => {
            const isCompleted = phase.percentage === 100;
            const isRunning = phase.percentage > 0 && phase.percentage < 100;

            return (
              <div key={phase.phaseName} className="relative pl-10 sm:pl-12">
                {index !== phaseProgress.length - 1 && (
                  <div className="absolute left-4 sm:left-5 top-8 h-12 w-0.5 bg-gray-200" />
                )}

                <div className="absolute left-0 top-0">
                  {isCompleted ? (
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-green-100 flex items-center justify-center">
                      <CheckCircle2 size={18} className="text-green-600" />
                    </div>
                  ) : isRunning ? (
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-100 flex items-center justify-center">
                      <Loader2 size={18} className="text-blue-600 animate-spin" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-100 flex items-center justify-center">
                      <Circle size={16} className="text-gray-400" />
                    </div>
                  )}
                </div>

                <div className="bg-slate-50/70 border border-slate-100 rounded-xl p-3.5 sm:p-4 hover:bg-white hover:shadow-md transition-all">
                  <div className="flex justify-between items-center">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4
                          className="font-bold text-sm sm:text-base"
                          style={{ color: phase.color }}
                        >
                          {phase.phaseName}
                        </h4>
                        <span
                          className="px-2.5 py-0.5 rounded-full text-[11px] font-bold"
                          style={{
                            backgroundColor: `${phase.accent}20`,
                            color: phase.color,
                          }}
                        >
                          {phase.sectionCode}
                        </span>
                      </div>

                      <p className="text-xs text-gray-400 mt-1">
                        {phase.completed} of {phase.total} tasks completed
                      </p>
                    </div>

                    <div className="relative h-12 w-12 sm:h-14 sm:w-14 shrink-0">
                      <svg className="h-12 w-12 sm:h-14 sm:w-14 rotate-[-90deg]">
                        <circle
                          cx="24"
                          cy="24"
                          r="18"
                          stroke={`${phase.accent}30`}
                          strokeWidth="3.5"
                          fill="none"
                          className="sm:hidden"
                        />
                        <circle
                          cx="28"
                          cy="28"
                          r="22"
                          stroke={`${phase.accent}30`}
                          strokeWidth="4"
                          fill="none"
                          className="hidden sm:block"
                        />
                        <circle
                          cx="28"
                          cy="28"
                          r="22"
                          stroke={phase.accent}
                          strokeWidth="4"
                          fill="none"
                          strokeDasharray={138}
                          strokeDashoffset={
                            138 - (138 * phase.percentage) / 100
                          }
                          strokeLinecap="round"
                          className="hidden sm:block"
                        />
                      </svg>

                      <div className="absolute inset-0 flex items-center justify-center">
                        <span
                          className="text-[11px] sm:text-xs font-bold"
                          style={{ color: phase.color }}
                        >
                          {phase.percentage}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Accordions */}
      <div className="space-y-3">
        {Object.entries(groupedPhases).map(([phaseName, phaseData]) => (
          <OnboardingPhaseAccordion
            key={phaseName}
            phaseName={phaseName}
            applicableFor={phaseData.applicableFor}
            phaseData={phaseData}
            phaseAttachments={onboarding.phaseAttachments || []}
            getOneClientOnboarding={fetchData}
            clientId={onboarding.clientId._id}
            onChecklistUpdate={handleChecklistUpdate}
            isOpen={openPhases[phaseName]}
            onToggle={() =>
              setOpenPhases((prev) => ({
                ...prev,
                [phaseName]: !prev[phaseName],
              }))
            }
          />
        ))}
      </div>

      {/* History Drawer */}
      <OnboardingHistoryDrawer
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        history={history}
      />

      {/* ------------------------------------------------------------- */}
      {/* RED THEME RESPONSIVE ADD-ON SERVICES MODAL WITH STAGE SELECTOR */}
      {/* ------------------------------------------------------------- */}
      <AnimatePresence>
        {addOnModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-black/60 backdrop-blur-xs">
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 15 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 15 }}
              className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto border border-slate-100"
            >
              {/* Modal Header */}
              <div className="bg-[#DC2626] p-4 sm:p-5 text-white flex justify-between items-center sticky top-0 z-10 shadow-sm">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-white/10 rounded-lg">
                    <PackagePlus size={20} />
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-bold">
                      Add-On Service / Deal
                    </h3>
                    <p className="text-[11px] text-white/80">
                      {onboarding?.clientId?.clientName}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setAddOnModalOpen(false)}
                  className="p-1 rounded-lg hover:bg-white/10 transition-all text-white/80 hover:text-white"
                >
                  <X size={20} />
                </button>
              </div>

              {/* Modal Form */}
              <form onSubmit={handleAddOnSubmit} className="p-4 sm:p-6 space-y-4">
                {/* 1. Dynamic Product Category Selector */}
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-2 flex items-center justify-between">
                    <span>Select Product Category <span className="text-[#DC2626]">*</span></span>
                    {addOnForm.productCategory.length > 0 && (
                      <span className="text-[10px] text-[#DC2626] font-semibold bg-red-50 px-2 py-0.5 rounded-full border border-red-100">
                        {addOnForm.productCategory.length} Selected
                      </span>
                    )}
                  </label>

                  <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto p-1.5 border border-slate-200 rounded-xl bg-slate-50/50">
                    {defaultProductCategories?.map((cat) => {
                      const catName = cat.productCategory;
                      const selected = addOnForm.productCategory.includes(catName);
                      return (
                        <button
                          key={catName}
                          type="button"
                          onClick={() => handleCategoryToggle(catName)}
                          className={`px-3 py-2 rounded-lg text-xs font-semibold text-left border transition-all flex items-center justify-between gap-1 ${
                            selected
                              ? "bg-red-50 border-[#DC2626] text-[#DC2626] shadow-2xs font-bold"
                              : "bg-white border-slate-200 text-gray-700 hover:bg-gray-100"
                          }`}
                        >
                          <span className="truncate">{catName}</span>
                          {selected && <CheckCircle2 size={14} className="text-[#DC2626] shrink-0" />}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* 2. Specific Sub-Services Selector */}
                {availableServices.length > 0 && (
                  <div>
                    <label className="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-2 flex items-center justify-between">
                      <span className="flex items-center gap-1">
                        <Layers size={13} className="text-[#DC2626]" />
                        Select Services / Deliverables
                      </span>
                      {addOnForm.requirement.length > 0 && (
                        <span className="text-[10px] text-blue-600 font-semibold bg-blue-50 px-2 py-0.5 rounded-full border border-blue-100">
                          {addOnForm.requirement.length} Services Chosen
                        </span>
                      )}
                    </label>

                    <div className="flex flex-wrap gap-1.5 max-h-40 overflow-y-auto p-2 border border-slate-200 rounded-xl bg-slate-50/50">
                      {availableServices.map((service) => {
                        const selected = addOnForm.requirement.includes(service);
                        return (
                          <button
                            key={service}
                            type="button"
                            onClick={() => handleServiceToggle(service)}
                            className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-all flex items-center gap-1 ${
                              selected
                                ? "bg-[#DC2626] border-[#DC2626] text-white shadow-2xs font-semibold"
                                : "bg-white border-slate-200 text-gray-700 hover:bg-slate-100"
                            }`}
                          >
                            <span>{service}</span>
                            {selected && <CheckCircle2 size={12} className="text-white shrink-0" />}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* 3. Custom Scope / Requirement Input */}
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-1">
                    Additional Scope / Custom Deliverable
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. Custom API integration & campaign setup"
                    value={addOnForm.customRequirement}
                    onChange={(e) =>
                      setAddOnForm({ ...addOnForm, customRequirement: e.target.value })
                    }
                    className="w-full px-3 py-2 rounded-lg border border-slate-300 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-[#DC2626]"
                  />
                </div>

                {/* 4. Sales Pipeline Stage Selector */}
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-1">
                    Deal Stage
                  </label>
                  <select
                    value={addOnForm.stageId}
                    onChange={(e) =>
                      setAddOnForm({ ...addOnForm, stageId: e.target.value })
                    }
                    className="w-full px-3 py-2 rounded-lg border border-slate-300 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-[#DC2626] bg-white text-gray-800 font-medium"
                  >
                    <option value="">Default (Initial Stage - Prospecting)</option>
                    {salesStages.map((stg) => (
                      <option key={stg._id} value={stg._id}>
                        {stg.stageName} {stg.probability !== undefined ? `(${stg.probability}%)` : ""}
                      </option>
                    ))}
                  </select>
                </div>

                {/* 5. Invoice ID & Deal Value */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-1">
                      Invoice ID
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. INV-2026-0099"
                      value={addOnForm.invoiceId}
                      onChange={(e) =>
                        setAddOnForm({ ...addOnForm, invoiceId: e.target.value })
                      }
                      className="w-full px-3 py-2 rounded-lg border border-slate-300 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-[#DC2626]"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-1">
                      Deal Value (₹)
                    </label>
                    <input
                      type="number"
                      placeholder="e.g. 50000"
                      value={addOnForm.expectedValue}
                      onChange={(e) =>
                        setAddOnForm({ ...addOnForm, expectedValue: e.target.value })
                      }
                      className="w-full px-3 py-2 rounded-lg border border-slate-300 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-[#DC2626]"
                    />
                  </div>
                </div>

                {/* 6. Remarks */}
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-1">
                    Remarks
                  </label>
                  <textarea
                    rows={2}
                    placeholder="Add internal deal notes..."
                    value={addOnForm.remarks}
                    onChange={(e) =>
                      setAddOnForm({ ...addOnForm, remarks: e.target.value })
                    }
                    className="w-full px-3 py-2 rounded-lg border border-slate-300 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-[#DC2626] resize-none"
                  />
                </div>

                {/* Footer Buttons */}
                <div className="flex justify-end items-center gap-2 pt-3 border-t border-slate-100">
                  <button
                    type="button"
                    onClick={() => setAddOnModalOpen(false)}
                    className="px-4 py-2 rounded-lg border border-slate-300 text-xs sm:text-sm font-semibold text-gray-700 hover:bg-slate-50 transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={submittingAddOn}
                    className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#DC2626] text-white text-xs sm:text-sm font-semibold shadow hover:bg-[#B91C1C] active:scale-95 disabled:opacity-50 transition-all"
                  >
                    {submittingAddOn ? (
                      <>
                        <Loader2 size={15} className="animate-spin" />
                        Saving...
                      </>
                    ) : (
                      <>
                        <PackagePlus size={15} />
                        Add Service & Sync Checklists
                      </>
                    )}
                  </button>
                </div>
              </form>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ViewClientOnboarding;